import React, { useState } from "react";
import { Formik } from "formik";
import { Row, Col } from "react-bootstrap";
import * as EmailValidator from "email-validator";
import * as Yup from "yup";
import { useAuthDispatch } from "../Context";
import { useNavigate } from "react-router-dom";
import { autoComplete } from "../../services/pappers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import autoCompleteZipCode from "../../services/zipCodes";
import userValidationSchema from "../../validationSchemas/utilisateur.validation";

const Entreprise = ({ handleClick, data }) => {
  const { nom_entreprise, siren_formate, siren, siege = {} } = data;
  const { code_postal, ville, adresse_ligne_1, adresse_ligne_2 } = siege;

  return (
    <li
      className="denompicker-entreprise"
      onClick={() =>
        handleClick({
          denomination: nom_entreprise,
          siren,
          adresse: adresse_ligne_1,
          adresseComplement: adresse_ligne_2,
          codePostal: code_postal,
          ville: ville,
          pays: "France"
        })
      }
    >
      <span className="title">{nom_entreprise}</span>
      <span className="siren">{siren_formate}</span>
      <span className="adresse">
        {adresse_ligne_1} | {code_postal}, {ville}
      </span>
    </li>
  );
};

const ZipCode = ({ handleClick, data }) => {
  const { code, city } = data;

  return (
    <li
      className="zipCodePicker"
      onClick={() =>
        handleClick({
          city,
          code
        })
      }
    >
      <span className="cp">{code}</span>
      <span className="ville">{city}</span>
    </li>
  );
};

const ValidatedRegisterForm = props => {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const [listDenominations, setListDenominations] = useState([]);
  const [listZipCodes, setListZipCodes] = useState([]);
  const [allEntreprise, setAllEntreprise] = useState({
    denomination: "",
    siren: "",
    adresse: "",
    adresseComplement: "",
    codePostal: "",
    ville: "",
    pays: ""
  });

  return (
    <Formik
      initialValues={{
        ...allEntreprise,
        email: props.email,
        password: props.password
      }}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          props.handleSubmit(values);
          setSubmitting(false);
        }, 500);
      }}
      //********Handling validation messages yourself*******/
      validate={values => {
        let errors = {};
        if (!values.email) {
          errors.email = "Adresse E-mail nécessaire";
        } else if (!EmailValidator.validate(values.email)) {
          errors.email = "Adresse E-mail invalide";
        }

        const passwordRegex = /(?=.*[0-9])/;
        if (!values.password) {
          errors.password = "Mot de passe nécessaire";
        } else if (values.password.length < 2) {
          errors.password =
            "Votre mot de passe doit faire au moins 2 caractères de long.";
        } else if (!passwordRegex.test(values.password)) {
          errors.password =
            "Votre mot de passe doit contenir au moins un caractère spécial.";
        }

        return errors;
      }}
      //********Using Yum for validation********/

      validationSchema={userValidationSchema}
    >
      {props => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        } = props;

        const applyEntreprise = params => {
          console.log({ params });
          if (params.siren) setFieldValue("siren", params.siren);
          if (params.adresse) setFieldValue("adresse", params.adresse);
          if (params.codePostal) setFieldValue("codePostal", params.codePostal);
          if (params.ville) setFieldValue("ville", params.ville);
          if (params.denomination)
            setFieldValue("denomination", params.denomination);
          if (params.adresseComplement)
            setFieldValue("adresseComplement", params.adresseComplement);
          setListDenominations([]);
        };

        const applyZipCode = params => {
          console.log({ params });
          if (params.city) setFieldValue("ville", params.city);
          if (params.code) setFieldValue("codePostal", params.code);

          setListZipCodes([]);
        };

        const handleSearchDenomination = async e => {
          handleChange(e);

          const { value: denomination = "" } = e.target;

          if (denomination.length <= 3) {
            setListDenominations([]);
            return;
          }

          const list = await autoComplete(denomination);
          setListDenominations(list);
        };

        const handleSearchZipCode = async e => {
          handleChange(e);

          const { value: zipCode = "" } = e.target;

          console.log(zipCode);
          if (zipCode.length <= 1) {
            setListZipCodes([]);
            return;
          }

          const list = await autoCompleteZipCode(zipCode);
          setListZipCodes(list);
        };

        const handleValidateSearchDenomination = e => {
          try {
            if (e.key === "Enter") {
              e.preventDefault();

              const {
                nom_entreprise,
                siren,
                siege = {}
              } = listDenominations[0];
              const {
                code_postal,
                ville,
                adresse_ligne_1,
                adresse_ligne_2
              } = siege;

              applyEntreprise({
                denomination: nom_entreprise,
                siren,
                codePostal: code_postal,
                ville,
                adresse: adresse_ligne_1,
                adresseComplement: adresse_ligne_2
              });

              console.log({ xxx: listDenominations[0] });
            }
          } catch (err) {}
        };

        const handleValidateSearchZipCode = e => {
          try {
            if (e.key === "Enter") {
              e.preventDefault();

              if (!listZipCodes) return;
              const { code, city } = listZipCodes[0];

              applyZipCode({ city, code });
            }
          } catch (err) {}
        };

        const renderDenominationPicker = () => {
          const slicedLines = listDenominations.slice(0, 3);
          const lines = slicedLines.map(denom => (
            <Entreprise data={denom} handleClick={applyEntreprise} />
          ));

          return (
            <ul className={`denomPicker ${lines.length > 0 ? "" : "hidden"}`}>
              {lines}
            </ul>
          );
        };

        const renderZipCodesPicker = () => {
          const slicedLines = listZipCodes.slice(0, 5);
          const lines = slicedLines.map(zip => (
            <ZipCode data={zip} handleClick={applyZipCode} />
          ));

          return (
            <ul
              className={`denomPicker zipCode${
                lines.length > 0 ? "" : "hidden"
              }`}
            >
              {lines}
            </ul>
          );
        };

        return (
          <form name="register" onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} md={6}>
                <label htmlFor="lastName" className="form-label">
                  Nom
                </label>
                <input
                  name="lastName"
                  type="text"
                  className={`form-control ${errors.lastName &&
                    touched.lastName &&
                    "is-invalid"}`}
                  value={values.lastName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.lastName && touched.lastName && (
                  <div className="invalid-feedback">{errors.lastName}</div>
                )}
              </Col>{" "}
              <Col xs={12} md={6}>
                <label htmlFor="lastName" className="form-label">
                  Prénom
                </label>
                <input
                  name="firstName"
                  type="text"
                  className={`form-control ${errors.firstName &&
                    touched.firstName &&
                    "is-invalid"}`}
                  value={values.firstName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.firstName && touched.firstName && (
                  <div className="invalid-feedback">{errors.firstName}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <label htmlFor="email" className="form-label">
                  Adresse E-Mail
                </label>
                <input
                  name="email"
                  type="email"
                  className={`form-control ${errors.email &&
                    touched.email &&
                    "is-invalid"}`}
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.email && touched.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="phone" className="form-label">
                  Téléphone
                </label>
                <input
                  name="phone"
                  type="number"
                  className={`form-control ${errors.phone &&
                    touched.phone &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.phone && touched.phone && (
                  <div className="invalid-feedback">{errors.phone}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={8} md={8}>
                <label htmlFor="denomination" className="form-label">
                  Dénomination / Raison sociale
                </label>
                <input
                  name="denomination"
                  type="text"
                  className={`form-control ${errors.denomination &&
                    touched.denomination &&
                    "is-invalid"}`}
                  value={values.denomination}
                  onChange={e => handleSearchDenomination(e)}
                  onKeyDown={handleValidateSearchDenomination}
                  autoComplete="new-password"
                  //  onBlur={handleSearchDenomination}
                />

                {errors.denomination && touched.denomination && (
                  <div className="invalid-feedback">{errors.denomination}</div>
                )}
                {renderDenominationPicker()}
              </Col>
              <Col xs={4} md={4}>
                <label htmlFor="siren" className="form-label">
                  Siren
                </label>
                <input
                  name="siren"
                  type="siren"
                  className={`form-control ${errors.siren &&
                    touched.siren &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.siren}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.siren && touched.siren && (
                  <div className="invalid-feedback">{errors.siren}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <label htmlFor="adresse" className="form-label">
                  Adresse
                </label>
                <input
                  name="adresse"
                  type="text"
                  className={`form-control ${errors.adresse &&
                    touched.adresse &&
                    "is-invalid"}`}
                  value={values.adresse}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.adresse && touched.adresse && (
                  <div className="invalid-feedback">{errors.adresse}</div>
                )}
              </Col>
              <Col xs={12} md={6}>
                <label htmlFor="adresse" className="form-label">
                  Adresse (Complément)
                </label>
                <input
                  name="adresseComplement"
                  type="text"
                  value={values.adresseComplement}
                  onChange={handleChange}
                  className="form-control"
                  onBlur={handleBlur}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={3}>
                <label htmlFor="codePostal" className="form-label">
                  Code Postal
                </label>
                <input
                  name="codePostal"
                  type="text"
                  className={`form-control ${errors.codePostal &&
                    touched.codePostal &&
                    "is-invalid"}`}
                  value={values.codePostal}
                  onKeyDown={handleValidateSearchZipCode}
                  onChange={handleSearchZipCode}
                  onBlur={handleBlur}
                />

                {errors.codePostal && touched.codePostal && (
                  <div className="invalid-feedback">{errors.codePostal}</div>
                )}
                {renderZipCodesPicker()}
              </Col>
              <Col xs={12} md={9}>
                <label htmlFor="ville" className="form-label">
                  Ville
                </label>
                <input
                  name="ville"
                  type="text"
                  value={values.ville}
                  onChange={handleChange}
                  className={`form-control ${errors.ville &&
                    touched.ville &&
                    "is-invalid"}`}
                  onBlur={handleBlur}
                />
                {errors.ville && touched.ville && (
                  <div className="invalid-feedback">{errors.ville}</div>
                )}
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <label htmlFor="password" className="form-label">
                  Mot de passe
                </label>
                <input
                  name="password"
                  type="password"
                  className={`form-control ${errors.password &&
                    touched.password &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <span className="text-muted">
                  Doit contenir au moins un caractère spécial et un chiffre
                </span>

                {errors.password && touched.password && (
                  <div className="invalid-feedback">{errors.password}</div>
                )}
              </Col>
              <Col xs={6}>
                <label htmlFor="passwordConfirmation" className="form-label">
                  Mot de passe (confirmation)
                </label>
                <input
                  name="passwordConfirmation"
                  type="password"
                  className={`form-control ${errors.passwordConfirmation &&
                    touched.passwordConfirmation &&
                    "is-invalid"}`}
                  autoComplete="new-password"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.passwordConfirmation &&
                  touched.passwordConfirmation && (
                    <div className="invalid-feedback">
                      {errors.passwordConfirmation}
                    </div>
                  )}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <br />
                <button
                  className="btn btn-cta"
                  type="submit"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faCheckCircle} size="sm" />
                  &nbsp; Continuer
                  <div className="btn-cta-overlay"></div>
                </button>
              </Col>{" "}
              <Col xs={12}>
                <hr />
                <span>
                  <a
                    className="callToActionLink"
                    onClick={() => navigate("/login")}
                  >
                    Retour
                  </a>{" "}
                </span>
              </Col>
            </Row>
          </form>
        );
      }}
    </Formik>
  );
};

export default ValidatedRegisterForm;
